import { ReleaseOutboxRecordDto } from '../dtos/release-outbox-record.dto';

/**
 * Release outbox records request DTO
 */
export class ReleaseOutboxRecordsRequest {
	records!: ReleaseOutboxRecordDto[];
}
